import useSWR from 'swr'
import { get } from '@/utils/request'
import { commonSWROptions } from './useAdmin'

const getClubMembers = (club) =>
  get('club_members', { club }).then((res) => {
    if (res.ok) {
      return res.club_members
    }
    return []
  })

const useClubMembers = (club) => {
  return useSWR(club ? 'club_members' : null, () => getClubMembers(club), { ...commonSWROptions, fallbackData: [] }) as {
    data: any[]
    mutate: any
    isValidating: boolean
  }
}

export default useClubMembers
